module.exports = __webpack_public_path__ + "static/media/delete.d92d6d9d.svg";